// extracted by mini-css-extract-plugin
export default {"wrapper":"DirectAnswerChatAction-module__wrapper--e267c","input":"DirectAnswerChatAction-module__input--b695a","icon":"DirectAnswerChatAction-module__icon--bbbc7"};